export function getAnalyticsSessionId() {
    return getCookie("analyticssessionid");
}

function getCookie(name: string) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    if (parts.length >= 2) {
        const lastElement = parts.pop();
        return lastElement && lastElement.split(";").shift();
    }

    return null;
}
